// src/features/executive/sales/hooks/use-sales-summary.ts
import { useExecutiveQuery } from 'features/executive/shared/hooks/use-executive-query'
import SalesApi from 'api/executive/sales.api'
import type {
  GetSalesSummaryParams,
  SalesSummaryResponse,
} from 'api/executive/executive.types'

export function useSalesSummary() {
  return useExecutiveQuery<GetSalesSummaryParams, SalesSummaryResponse>(
    'sales.summary',
    SalesApi.getSalesSummary,
    (f) => {
      if (!f.dateRange?.start || !f.dateRange?.end) return null
      return {
        dateFrom: f.dateRange.start,
        dateTo: f.dateRange.end,
        branchId: f.branchId ?? undefined,
        doctorId: f.doctorId ?? undefined,
        procedureId: f.procedureId ?? undefined,
        txCategoryId: f.txCategoryId ?? undefined,
        patientType: f.patientType ?? undefined,
        appointmentStatus: f.appointmentStatus ?? undefined,
      }
    }
  )
}
